type Props = {
  size?: number;
  color?: string;
};

// Chrome rasterises SVG elements at their display size, then applies CSS
// transforms during compositing — discarding the extra resolution. Rendering at
// 2× and scaling back forces a higher-resolution raster for smoother edges.
// `will-change: transform` ensures Chrome allocates a dedicated GPU layer.
const SUPERSAMPLE = 2;

export const KlipboardIcon = ({ size = 35, color = "#ED017F" }: Props) => {
  const h = Math.round((size * 35) / 47);
  return (
  <svg
    width={size * SUPERSAMPLE}
    height={h * SUPERSAMPLE}
    viewBox="0 0 47 35"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="nonzero"
    shapeRendering="geometricPrecision"
    style={{
      transform: `scale(${1 / SUPERSAMPLE})`,
      transformOrigin: "top left",
      marginRight: -(size * (SUPERSAMPLE - 1)),
      marginBottom: -(h * (SUPERSAMPLE - 1)),
      willChange: "transform",
    }}
  >
    <g fill={color} transform="translate(0.563 0.41) scale(1.4085)">
      <path d="M17.3483458,22.806941 L9.57007575,14.982641 C7.94233575,13.345241 7.94233575,10.689841 9.57007575,9.052451 L17.3483458,1.228131 C18.9760458,-0.409255 21.6158458,-0.409255 23.2435458,1.228131 L31.0218458,9.052451 C32.6495458,10.689841 32.6495458,13.345241 31.0218458,14.982641 L23.2435458,22.806941 C21.6158458,24.444341 18.9760458,24.444341 17.3483458,22.806941 Z M21.2687458,20.847541 L29.0738458,12.996141 C29.6112458,12.455641 29.6112458,11.579441 29.0738458,11.038941 L21.2687458,3.187591 C20.7314458,2.647051 19.8604458,2.647051 19.3231458,3.187591 L11.5179458,11.038941 C10.9806458,11.579441 10.9806458,12.455641 11.5179458,12.996141 L19.3231458,20.847541 C19.8604458,21.388041 20.7314458,21.388041 21.2687458,20.847541 Z" />
      <path d="M8.99904575,22.806841 L1.22080575,14.982541 C-0.40693525,13.345141 -0.40693525,10.689741 1.22080575,9.052361 L8.99904575,1.228041 C10.6267457,-0.409347 13.2665458,-0.409347 14.8943458,1.228041 L22.6725458,9.052361 C24.3002457,10.689741 24.3002457,13.345141 22.6725458,14.982541 L14.8943458,22.806841 C13.2665458,24.444241 10.6267457,24.444241 8.99904575,22.806841 Z M12.9329458,20.847441 L20.7380458,12.996041 C21.2754458,12.455541 21.2754458,11.579441 20.7380458,11.038841 L12.9329458,3.187501 C12.3955458,2.646961 11.5246458,2.646961 10.9872458,3.187501 L3.18216575,11.038841 C2.64480575,11.579441 2.64480575,12.455541 3.18216575,12.996041 L10.9872458,20.847441 C11.5246458,21.387941 12.3955458,21.387941 12.9329458,20.847441 Z" />
    </g>
  </svg>
  );
};
